import { StubModule } from "../../../shared/components/StubModule";
import { useConnectAction } from "../../../services/auth/useConnectAction";
import { MyQueuePanel } from "./MyQueuePanel";

interface MyQueueModuleProps {
  readonly onBack?: () => void;
  readonly onOpenSettings?: () => void;
}

export function MyQueueModule({
  onBack,
  onOpenSettings,
}: Readonly<MyQueueModuleProps> = {}) {
  const connectAction = useConnectAction("myqueue", "Connect MyQueue");
  // `connectAction.connected` is driven by adapter.onTokenChange, so it
  // flips to true once the silent re-auth kicked off in useConnectAction
  // completes after a page refresh.
  const connected = connectAction?.connected ?? false;

  if (connected) {
    return <MyQueuePanel onBack={onBack} />;
  }

  return (
    <StubModule
      title="MyQueue"
      subtitle="Task queue and timeclock"
      noticeTitle="Connect MyQueue to continue"
      noticeMessage="MyQueue uses AWS Cognito + Azure SAML federation."
      features={[
        "Task search with multi-field filters",
        "Task actions: start, pause, complete",
        "Priority badges (VIP / RUSH)",
        "Timeclock: punch in / out / break",
        "QC workflow with reviewer assignment",
        "Invoice lookups + paginated results",
      ]}
      onBack={onBack}
      connectAction={connectAction}
      onOpenSettings={onOpenSettings}
    />
  );
}
